import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Battlefield from "@/pages/Battlefield";
import WarRoomPage from "@/pages/WarRoomPage";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Battlefield />} />
          <Route path="/warroom" element={<WarRoomPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast:
              "!bg-[#010308]/95 !border !border-white/10 !text-white backdrop-blur-xl !rounded-none",
            description: "!text-slate-400",
            title: "font-['Unbounded',sans-serif] tracking-tight",
          },
        }}
      />
    </div>
  );
}
